// utils/format.ts
export function formatMoney(amount: number, currency: string) {
  try {
    return new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency: currency?.toUpperCase() || "EUR",
    }).format(amount);
  } catch {
    return `${amount} ${currency}`;
  }
}

// Si jamais l’API ne renvoie pas countryCode, on tente une dérivation simple
const NAME_TO_ISO2: Record<string, string> = {
  "belgique": "BE",
  "france": "FR",
  "états-unis": "US",
  "etats-unis": "US",
  "usa": "US",
  "royaume-uni": "GB",
  "allemagne": "DE",
  "espagne": "ES",
  "italie": "IT",
  "australie": "AU",
  "afrique du sud": "ZA",
  "rdc": "CD",
  "république démocratique du congo": "CD",
};

export function ensureIso2(codeOrName?: string) {
  if (!codeOrName) return undefined;
  const s = codeOrName.trim();
  if (s.length === 2) return s.toUpperCase();
  const k = s.toLowerCase();
  return NAME_TO_ISO2[k] || undefined;
}
